import { GmailScopes, OutlookScopes } from '@zaplify/channel-accounts/shared';

export const SocketEvents = {
    billing: {
        PAYMENT_SUCCEEDED: 'payment_succeeded',
        SEAT_ASSIGNED: 'seat_assigned',
        SUBSCRIPTION_CHANGED: 'subscription_changed',
        SEAT_UNASSIGNED: 'seat_unassigned',
        CREDIT_SPENT: 'credit_spent',
    },
    integration: {
        UPSALES_ACCOUNT_CREATED: 'upsales_account_created',
    },
};

export const LocalStorageKeys = {
    INVITATION_ID: 'invitation_id',
    INVITATION_SECURITY_TOKEN: 'invitation_securityToken',
    INVITATION_STATUS: 'invitation_status',
    PLAN: 'plan',
    REFERRAL_LINK: 'referral_link_id',
};

const emailConfigProviders = ['ms', 'google'] as const;
export const emailConfig: {
    [key in (typeof emailConfigProviders)[number]]: {
        clientId: string;
        redirectUrl: string;
        scopes: string[];
    };
} = {
    ms: {
        clientId: import.meta.env.VITE_OAUTH_OUTLOOK_CLIENT_ID,
        redirectUrl: window.location.origin,
        scopes: OutlookScopes.all,
    },
    google: {
        clientId: import.meta.env.VITE_OAUTH_GOOGLE_CLIENT_ID,
        redirectUrl: window.location.origin,
        scopes: GmailScopes.all,
    },
};
